import { z } from 'zod';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse } from '../../utils/listResponse';
import { savedViewSchema } from '../models/savedView.schema';
import { savedViewsListQuerySchema } from './list.schema';

export type SavedViewsListQuery = PaginationQuery & { queueId?: number };

export const list = (query: SavedViewsListQuery = {}) => {
  return {
    endpoint: `/saved_views`,
    method: 'GET',
    responseSchema: listResponse(savedViewSchema),
    query: { ...query, includeTotal: true },
    querySchema: savedViewsListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
